import { render, staticRenderFns } from "./PromotionDetailsHeader.vue?vue&type=template&id=a8a00dbc&scoped=true"
import script from "./PromotionDetailsHeader.vue?vue&type=script&lang=js"
export * from "./PromotionDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailsHeader.vue?vue&type=style&index=0&id=a8a00dbc&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a00dbc",
  null
  
)

export default component.exports